import { useEffect } from 'react'

import { useSessionContext } from 'hooks/SessionContext'
import { useStoreContext } from 'hooks/StoreContext'

import Api from 'services/api'

const useArchivedDevices = (refresh?: number) => {
  const { session: { impersonateDealerId, dealerId } } = useSessionContext()
  const resolvedDealerId = impersonateDealerId || dealerId

  /*
   *  TODO: When this all gets converted to React we will need to remove "isArchivedDevicesLoaded"
   *  and setIsArchivedDevicesLoaded. These were put here temporarily because of collisions that
   *  were happening when transitioning from a archived devices backbone collection to a non
   *  backbone collection screen. See https://tranecortex.atlassian.net/browse/DWA-2629
   */
  const {
    archivedDevices,
    setArchivedDevices,
    isArchivedDevicesLoaded,
    setIsArchivedDevicesLoaded
  } = useStoreContext()

  useEffect(() => {
    Api.ArchivedDevices.list(resolvedDealerId)
      .then((res) => {
        setArchivedDevices(res)
        setIsArchivedDevicesLoaded(true)
      })
      .catch(() => {
        setArchivedDevices(null)
        setIsArchivedDevicesLoaded(true)
      })
  }, [resolvedDealerId, refresh]) // eslint-disable-line react-hooks/exhaustive-deps

  return { archivedDevices, isArchivedDevicesLoaded }
}

export default useArchivedDevices
